import { apiInstance } from './api';
import { ApiRoutes } from './consts';

export const getReviewById = async (id: string) => {
  return apiInstance.get(`${ApiRoutes.Reviews}/${id}`);
};

export const getPaginatedReviews = async ({
  limit,
  page,
  order,
  sortBy,
  text,
  startDate,
  endDate,
  minRating,
  maxRating,
  isFeedback,
}: {
  page: number;
  limit: number;
  sortBy?: 'createdAt' | 'customer' | 'photos' | 'rating';
  order?: 'ASC' | 'DESC';
  text?: string;
  startDate?: string;
  endDate?: string;
  minRating?: number;
  maxRating?: number;
  isFeedback?: boolean;
}) => {
  return apiInstance.get(`${ApiRoutes.Reviews}/`, {
    params: { page, limit, sortBy, order, text, startDate, endDate, minRating, maxRating, isFeedback },
  });
};

export const createReview = async (data: {
  requestId: string;
  rating: string;
  images?: File[];
  comment?: string;
  accessToken?: string;
  businessId?: string;
  badReasons?: string[];
  isFeedback?: boolean;
}) => {
  const formData = new FormData();
  if (data?.images) {
    data?.images.forEach((image: File) => {
      formData.append('files', image);
    });
  }

  formData.append('rating', data?.rating);
  formData.append('review', data?.comment ?? '');
  formData.append('requestId', data?.requestId);
  
  // Add bad reasons if provided
  if (data?.badReasons && data.badReasons.length > 0) {
    data.badReasons.forEach((reason) => {
      formData.append('badReasons', reason);
    });
  }
  
  // Add isFeedback parameter if provided
  if (data?.isFeedback !== undefined) {
    formData.append('isFeedback', data.isFeedback.toString());
  }

  return apiInstance.post(
    `${ApiRoutes.Reviews}/`, 
    formData, 
    data.accessToken ? {
      headers: {
        Authorization: `Bearer ${data.accessToken}`,
        ...(data.businessId ? { 'ECHO-Business-ID': data.businessId } : {}),
      }
    } : undefined
  );
};

export const submitAIFeedback = async (
  reviewId: string,
  isPositive: boolean
) => {
  return apiInstance.put(`${ApiRoutes.Reviews}/${reviewId}/ai-feedback`, {
    aiFeedback: isPositive,
  });
};

export const markReviewAsResolved = async (
  reviewId: string,
  resolved: boolean
) => {
  return apiInstance.patch(`${ApiRoutes.Reviews}/${reviewId}/resolved`, {
    resolved,
  });
};

// Feedback Notes API functions
export const getFeedbackNotes = async (reviewId: string) => {
  return apiInstance.get(`${ApiRoutes.Reviews}/${reviewId}/feedback-notes`);
};

export const createFeedbackNote = async (reviewId: string, description: string, createCampaign?: boolean) => {
  return apiInstance.post(`${ApiRoutes.Reviews}/${reviewId}/feedback-notes`, {
    description,
    createCampaign,
  });
};

export const updateFeedbackNote = async (noteId: string, description: string) => {
  return apiInstance.put(`${ApiRoutes.Reviews}/feedback-notes/${noteId}`, {
    description,
  });
};

export const deleteFeedbackNote = async (noteId: string) => {
  return apiInstance.delete(`${ApiRoutes.Reviews}/feedback-notes/${noteId}`);
};

export const getGoogleReviews = async (filters?: {
  minRating?: number;
  maxRating?: number;
  startDate?: string;
  endDate?: string;
  sortBy?: string;
  order?: string;
  limit?: number;
  offset?: number;
}) => {
  // const googleAccessToken = localStorage.getItem('googleAccessToken');
  return apiInstance.get('/reviews/google', {
    // headers: {
    //   'google-access-token': googleAccessToken,
    // },
    params: filters,
  });
}; //

export const getExternalReviews = async (filters?: { minRating?: number; maxRating?: number; startDate?: string; endDate?: string; sortBy?: string; order?: string; limit?: number; page?: number }) => {
  // const googleAccessToken = localStorage.getItem('googleAccessToken');
  return apiInstance.get('/reviews/external', {
    params: filters,
  });
};

export const postReply = async (
  reviewId: string,
  comment: string,
) => {
  return apiInstance.put(`/reviews/${reviewId}/reply`, {
    comment,
  },);
};

export const updateReply = async (
  reviewId: string,
  comment: string
) => {
  return apiInstance.put(
    `/reviews/${reviewId}/reply/update`,
    {
      comment,
    },
  );
};

export const deleteReply = async (
  reviewId: string,
) => {

  return apiInstance.delete(`/reviews/${reviewId}/reply`);
};
